// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import styles from './pricing_lobby.module.less';
import {Period_slider} from './period_slider';
import Icon_triangle_down from '../../img/icons/24/triangle_down.svg';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import Icon_check from '../../img/icons/16/check.svg';
import {Button} from '../../../../hola/pub/lib/button';
import Mask_group from '../../img/mask_group.svg';
import {Lobby_cards} from './lobby_cards';
import {Editor} from '../../../../shared/editor/editor';
import {Dynamic_heading} from '../../../../shared/editor/title_header_select';

export const PROXY_NAMES = {
    [Proxy_type.SDC]: 'Shared Datacenter Proxies',
    [Proxy_type.DDC]: 'Dedicated Datacenter Proxies',
    [Proxy_type.ISP]: 'Global ISP Proxies',
    [Proxy_type.ISPPREM]: 'Search Engine ISP Proxies',
    [Proxy_type.RES]: 'Rotating Residential Proxies'
};

interface i_connect_banner_props {
    cls?: string;
    show_icon?: boolean;
}
const Connect_banner = ({cls, show_icon=true}: i_connect_banner_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.connect_banner, cls)}>
      {show_icon && <div className={styles.icon_container}>
        <Mask_group/>
      </div>}
      <p className={cn(theme.p16, theme.med)}>
        Need help finding the right proxy package for you?
      </p>
      <Button caption={'Get in touch'} color={'black'} round={false}
        to={'mailto:support@toolip.io'} size={'sm'}/>
    </div>;
};

interface i_product_dropdown_props {
    selected_type: Proxy_type;
    on_type_change: (type: Proxy_type)=>void;
    cls?: string;
    proxy_names?: typeof PROXY_NAMES;
}
const Product_dropdown = (props: i_product_dropdown_props)=>{
    const {theme} = useContext(Settings_context);
    const {selected_type, on_type_change, cls,
        proxy_names = PROXY_NAMES} = props;
    const [is_open, set_is_open] = useState(false);
    const toggle_dropdown = ()=>set_is_open(!is_open);
    return <div className={cn(styles.product_dropdown, cls,
      is_open && styles.open)}>
      <div className={styles.dropdown_trigger} onClick={toggle_dropdown}>
        <p className={cn(theme.p14, theme.med)}>
          {proxy_names[selected_type]}
        </p>
        <div className={styles.icon_container}>
          <Icon_triangle_down className={styles.triangle_icon}/>
        </div>
      </div>
      {is_open &&
        <div className={styles.dropdown_wrapper}>
          <div className={styles.divider}/>
          <div className={styles.dropdown_content}>
            {Object.entries(proxy_names).map(([type, name])=>
              <div
                key={type}
                className={cn(styles.dropdown_item,
                  selected_type==type && styles.selected)}
                onClick={()=>{
                  on_type_change(type as Proxy_type);
                  set_is_open(false);
                }}
              >
                <p className={cn(theme.p12,
                  selected_type==type ? theme.med : theme.reg,
                  selected_type==type ? theme.color_n700 : theme.color_n600
                )}>
                  {name}
                </p>
                {selected_type==type &&
                  <div className={styles.icon_container}>
                    <Icon_check/>
                  </div>
                }
              </div>
            )}
          </div>
        </div>
      }
    </div>;
};

interface i_menu_item_props {
    type: Proxy_type;
    name: string;
    selected: boolean;
    on_click: (type: Proxy_type)=>void;
}
const Menu_item = ({type, name, selected, on_click}: i_menu_item_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.menu_item, styles[type],
      selected && styles.selected)} onClick={()=>on_click(type)}>
      <div className={styles.item_content}>
        <p className={cn(theme.p14, selected ? theme.med : theme.reg)}>
          {name}
        </p>
      </div>
    </div>;
};

interface i_menu_props {
    selected_type: Proxy_type;
    on_type_change: (type: Proxy_type)=>void;
    proxy_names?: typeof PROXY_NAMES;
}
const Menu = ({selected_type, on_type_change, proxy_names =
    PROXY_NAMES}: i_menu_props)=>{
    return <div className={styles.menu_wrapper}>
      <div className={cn(styles.menu, styles[selected_type])}>
        {Object.entries(proxy_names).map(([type, name])=>
          <Menu_item key={type} type={type as Proxy_type}
            name={name} selected={selected_type == type}
            on_click={on_type_change}/>
        )}
      </div>
      <Connect_banner show_icon={true}/>
    </div>;
};

interface i_pricing_lobby_props {
    title?: string;
    title_tag?: string;
    sdc_name?: string;
    ddc_name?: string;
    isp_name?: string;
    ispprem_name?: string;
    res_name?: string;
}

export const Pricing_lobby_editor = ({value, on_change})=>{
    const editors = [
        {
            key: 'title',
            label: 'Page Title',
            type: 'text' as const
        },
        {
          key: 'title_tag',
          label: 'Title Tag',
          type: 'select_tag_selector' as const
        },
        {
            key: 'sdc_name',
            label: 'Shared Datacenter Proxies Name',
            type: 'text' as const
        },
        {
            key: 'ddc_name',
            label: 'Dedicated Datacenter Proxies Name',
            type: 'text' as const
        },
        {
            key: 'isp_name',
            label: 'Global ISP Proxies Name',
            type: 'text' as const
        },
        {
            key: 'ispprem_name',
            label: 'Search Engine ISP Proxies Name',
            type: 'text' as const
        },
        {
            key: 'res_name',
            label: 'Rotating Residential Proxies Name',
            type: 'text' as const
        }
    ];
    return <Editor
      value={value}
      editors={editors}
      on_change={on_change}
    />;
};


export const Pricing_lobby = (props: i_pricing_lobby_props = {})=>{
    const {theme} = useContext(Settings_context);
    const [selected_type, set_selected_type] =
        useState<Proxy_type>(Proxy_type.SDC);
    const handle_type_change = (type: Proxy_type)=>{
        set_selected_type(type);
    };
    const title = props.title || 'Pricing';
    const custom_proxy_names = {
        ...PROXY_NAMES,
        [Proxy_type.SDC]: props.sdc_name || PROXY_NAMES[Proxy_type.SDC],
        [Proxy_type.DDC]: props.ddc_name || PROXY_NAMES[Proxy_type.DDC],
        [Proxy_type.ISP]: props.isp_name || PROXY_NAMES[Proxy_type.ISP],
        [Proxy_type.ISPPREM]: props.ispprem_name ||
            PROXY_NAMES[Proxy_type.ISPPREM],
        [Proxy_type.RES]: props.res_name || PROXY_NAMES[Proxy_type.RES]
    };
    return <div className={cn(theme.container, styles.container)}>
      <div className={styles.root}>
        <div className={styles.header}>
        <Dynamic_heading tag={props.title_tag || 'h3'}>{title}
        </Dynamic_heading>
          <Period_slider proxy_type={selected_type}/>
        </div>
        <Product_dropdown
          selected_type={selected_type}
          on_type_change={handle_type_change}
          proxy_names={custom_proxy_names}
        />
        <div className={styles.mid_layout}>
          <Dynamic_heading tag={props.title_tag || 'h3'}>{title}
          </Dynamic_heading>
          <div className={styles.mid_controls}>
            <Product_dropdown
              selected_type={selected_type}
              on_type_change={handle_type_change}
              proxy_names={custom_proxy_names}
              cls={styles.mid_dropdown}
            />
            <Period_slider proxy_type={selected_type}/>
          </div>
        </div>
        <div className={styles.content}>
          <Menu selected_type={selected_type}
            on_type_change={handle_type_change}
            proxy_names={custom_proxy_names}
          />
          <Lobby_cards selected_type={selected_type}/>
        </div>
      </div>
    </div>;
};
